<template>
  <v-container
    ref="container"
    class="fill-height container pt-8"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="4"
      >
        <app-card class="mt-4 text-center">
          <v-img
            class="rounded-circle elevation-6 mt-n12 d-inline-block"
            :src="$http.imaginary('https://storage.service.lecalamedor.fr/strapi/Woman_with_wax_tablets_and_stylus_so_called_Sappho_Fresco_Pompeii_Naples_National_Archaeological_Museum_0bc99defca.jpg', {height: 128})"
            width="128"
          />

          <v-card-text class="text-center">
            <h2 class="text-h2 mb-3 text--primary">
              Inscription
            </h2>

            <p class="text--secondary">
              <i>Nota bene :</i> ce formulaire ne peut pas être enregistré. Merci de vous munir des informations nécessaires afin de le renseigner en une fois.
            </p>
          </v-card-text>
        </app-card>
      </v-col>

      <v-col
        cols="12"
        md="8"
      >
        <material-card
          color="primary"
          icon="mdi-account-outline"
        >
          <template #title>
            Créer votre profil
          </template>

          <v-form>
            <v-container class="py-0">
              <h2>Enseignant(e) responsable</h2>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="firstname"
                    required
                    label="Prénom"
                    :error-messages="firstnameErrors"
                    @blur="$v.firstname.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="lastname"
                    required
                    label="Nom"
                    :error-messages="lastnameErrors"
                    @blur="$v.lastname.$touch()"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="phone"
                    required
                    label="Téléphone personnel de l'enseignant(e) (pour la remise des diplômes)"
                    :error-messages="phoneErrors"
                    @blur="$v.phone.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="email"
                    required
                    label="Adresse électronique de l'enseignant(e)"
                    :error-messages="emailErrors"
                    @blur="$v.email.$touch()"
                  />
                </v-col>
              </v-row>

              <h2>Etablissement</h2>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-autocomplete
                    v-model="schoolAcademy"
                    required
                    :error-messages="schoolAcademyErrors"
                    label="Académie"
                    item-text="label"
                    item-value="id"
                    :items="rsc.academies"
                    @change="forceRNE()"
                    @blur="$v.schoolAcademy.$touch();forceRNE()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="schoolRNE"
                    required
                    label="RNE de l'établissement"
                    :error-messages="schoolRNEErrors"
                    @blur="$v.schoolRNE.$touch()"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="schoolName"
                    required
                    label="Nom de l'établissement"
                    :error-messages="schoolNameErrors"
                    @blur="$v.schoolName.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="schoolPhone"
                    required
                    label="Numéro de téléphone de l'établissement"
                    :error-messages="schoolPhoneErrors"
                    @blur="$v.schoolPhone.$touch()"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="schoolAcademyOther"
                    required
                    label="Etat ou pays"
                    :error-messages="schoolAcademyOtherErrors"
                    @blur="$v.schoolAcademyOther.$touch()"
                  />
                </v-col>
              </v-row>

              <h4>Adresse</h4>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="schoolAdrStreet"
                    required
                    label="Numéro et voie de l'établissement"
                    :error-messages="schoolAdrStreetErrors"
                    @blur="$v.schoolAdrStreet.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="schoolAdrCode"
                    required
                    label="Code postal"
                    :error-messages="schoolAdrCodeErrors"
                    @blur="$v.schoolAdrCode.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                >
                  <v-text-field
                    v-model="schoolAdrCity"
                    required
                    label="Ville"
                    :error-messages="schoolAdrCityErrors"
                    @blur="$v.schoolAdrCity.$touch()"
                  />
                </v-col>
              </v-row>

              <h2>Compte</h2>
              <p class="text-caption">
                En complétant ce formulaire, vous allez créer un compte personnel pour vous connecter à votre espace Artifex. Vous aurez besoin de votre adresse email et du mot de passe que vous allez saisir ci dessous pour y accéder.
              </p>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="password"
                    required
                    label="Mot de passe"
                    type="password"
                    :error-messages="passwordErrors"
                    @blur="$v.password.$touch()"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="passwordConf"
                    required
                    type="password"
                    label="Confirmer votre mot de passe"
                    :error-messages="passwordConfErrors"
                    @blur="$v.passwordConf.$touch()"
                  />
                </v-col>
              </v-row>

              <h2>Quelques secondes de plus pour nous renseigner ?</h2>
              <v-radio-group
                v-model="discoverChoice"
                label="Comment avez-vous connu le concours ?"
              >
                <v-radio
                  label="Via un(e) ami(e)/collègue"
                  value="ami_collegue"
                />
                <v-radio
                  label="Via l'inspection académique"
                  value="academie"
                />
                <v-radio
                  label="Via une association"
                  value="association"
                />
                <v-radio
                  label="Autres"
                  value="autres"
                />
              </v-radio-group>

              <v-row v-if="discoverChoice == 'autres'">
                <v-col
                  cols="12"
                  md="6"
                >
                  <v-text-field
                    v-model="discoverMore"
                    label="Autres"
                  />
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12">
                  <v-textarea label="Observations" />
                </v-col>
              </v-row>

              <v-alert
                v-if="errorCaught"
                outlined
                type="error"
              >
                Une erreur est survenue lors de l'inscription sur nos serveurs.<br>
                {{ errorCaught }}
              </v-alert>

              <v-alert
                v-if="errorFormCaught"
                outlined
                type="error"
              >
                <div class="d-flex justify-space-between align-center">
                  <p>
                    Un ou plusieurs champs du formulaire semblent manquants ou incorrects.
                  </p>

                  <v-btn
                    text
                    color="secondary"
                    @click="$vuetify.goTo(0)"
                  >
                    Voir
                  </v-btn>
                </div>
              </v-alert>

              <div class="d-flex justify-space-between">
                <v-btn
                  text
                  class="my-8"
                  @click="$router.push('/account/login')"
                >
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn
                  color="primary"
                  class="my-8"
                  :disabled="inProgress"
                  :loading="inProgress"
                  @click="submit"
                >
                  Valider
                </v-btn>
              </div>
            </v-container>
          </v-form>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, email, sameAs, helpers } from 'vuelidate/lib/validators'

  const rne = helpers.regex('rne', /^[0-9]{7}[a-zA-Z]$/)
  // const pass = helpers.regex('pass', /^(?=.*[a-z])(?=.*[A-Z])[a-zA-Z\d]{8,}$/)
  const pass = helpers.regex('pass', /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/)

  export default {
    mixins: [validationMixin],

    validations: {
      firstname: { required },
      lastname: { required },
      password: { required, pass },
      passwordConf: {
        required,
        sameAsPassword: sameAs('password'),
      },
      phone: { required },
      email: {
        required,
        email,
        isUnique (value) {
          // standalone validator ideally should not assume a field is required
          if (value === '') return true
          return this.$auth.checkEmail(value)
        },
      },
      schoolAcademy: { required },
      schoolAcademyOther: { required },
      schoolName: { required },
      schoolPhone: { required },
      schoolAdrStreet: { required },
      schoolAdrCity: { required },
      schoolAdrCode: { required },
      schoolRNE: { required, rne },
    },

    data: () => ({
      inProgress: false,
      errorFormCaught: '',
      errorCaught: '',
      firstname: '',
      lastname: '',
      email: '',
      password: '',
      passwordConf: '',
      phone: '',
      schoolName: '',
      schoolRNE: '',
      schoolPhone: '',
      schoolAcademy: '',
      schoolAcademyOther: '',
      schoolAdrStreet: '',
      schoolAdrCity: '',
      schoolAdrCode: '',
      discoverChoice: '',
      discoverMore: '',
      rsc: {
        academies: [],
      },
    }),

    computed: {
      firstnameErrors () {
        const errors = []
        if (!this.$v.firstname.$dirty) return errors
        !this.$v.firstname.required && errors.push('Ce champ est manquant.')
        return errors
      },
      passwordErrors () {
        const errors = []
        if (!this.$v.password.$dirty) return errors
        !this.$v.password.required && errors.push('Ce champ est manquant.')
        !this.$v.password.pass && errors.push('Minimum 8 caractères, au moins une lettre majuscule, au moins une lettre minuscule, au moins un caractère spécial et un chiffre')
        return errors
      },
      passwordConfErrors () {
        const errors = []
        if (!this.$v.passwordConf.$dirty) return errors
        !this.$v.passwordConf.required && errors.push('Ce champ est manquant.')
        !this.$v.passwordConf.sameAsPassword && errors.push('Les mots de passe sont différents.')
        return errors
      },
      lastnameErrors () {
        const errors = []
        if (!this.$v.lastname.$dirty) return errors
        !this.$v.lastname.required && errors.push('Ce champ est manquant.')
        return errors
      },
      phoneErrors () {
        const errors = []
        if (!this.$v.phone.$dirty) return errors
        !this.$v.phone.required && errors.push('Ce champ est manquant.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.required && errors.push('Ce champ est manquant.')
        !this.$v.email.email && errors.push('Format de l\'email est incorrect')
        !this.$v.email.isUnique && errors.push('Email déjà utilisé')
        return errors
      },
      schoolNameErrors () {
        const errors = []
        if (!this.$v.schoolName.$dirty) return errors
        !this.$v.schoolName.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolAcademyErrors () {
        const errors = []
        if (!this.$v.schoolAcademy.$dirty) return errors
        !this.$v.schoolAcademy.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolAcademyOtherErrors () {
        const errors = []
        if (this.schoolAcademy === '60f4b492ff4b8d0a15d36bfb') return errors
        if (!this.$v.schoolAcademyOther.$dirty) return errors
        !this.$v.schoolAcademyOther.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolPhoneErrors () {
        const errors = []
        if (!this.$v.schoolPhone.$dirty) return errors
        !this.$v.schoolPhone.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolRNEErrors () {
        const errors = []
        if (!this.$v.schoolRNE.$dirty) return errors
        !this.$v.schoolRNE.required && errors.push('Ce champ est manquant.')
        !this.$v.schoolRNE.rne && errors.push('Le format du RNE semble incorrect (0000000a).')
        return errors
      },
      schoolAdrStreetErrors () {
        const errors = []
        if (!this.$v.schoolAdrStreet.$dirty) return errors
        !this.$v.schoolAdrStreet.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolAdrCityErrors () {
        const errors = []
        if (!this.$v.schoolAdrCity.$dirty) return errors
        !this.$v.schoolAdrCity.required && errors.push('Ce champ est manquant.')
        return errors
      },
      schoolAdrCodeErrors () {
        const errors = []
        if (!this.$v.schoolAdrCode.$dirty) return errors
        !this.$v.schoolAdrCode.required && errors.push('Ce champ est manquant.')
        return errors
      },
    },

    async mounted () {
      this.rsc.academies = await this.$lco.rsc.getAcademies()
      this.rsc.academies.sort((a, b) => {
        if (a[0] === '-') {
          return 1
        } else if (b[0] === '-') {
          return -1
        } else {
          return a.label.localeCompare(b.label)
        }
      })
    },

    methods: {
      forceRNE () {
        if (this.schoolAcademy === 72) {
          this.schoolRNE = '0000000a'
        }
      },
      submit () {
        this.inProgress = true
        this.errorCaught = ''
        this.errorFormCaught = ''

        this.$v.$touch()
        if (this.$v.$invalid) {
          this.errorFormCaught = 'Failed'
          this.inProgress = false
          return
        }
        this.$lco.participant.createNewOne({
          firstname: this.firstname,
          lastname: this.lastname,
          password: this.password,
          email: this.email,
          phone: this.phone,
          schoolName: this.schoolName,
          schoolRNE: this.schoolRNE,
          schoolPhone: this.schoolPhone,
          schoolAcademy: this.schoolAcademy,
          schoolAcademyOther: this.schoolAcademyOther,
          schoolAdrStreet: this.schoolAdrStreet,
          schoolAdrCity: this.schoolAdrCity,
          schoolAdrCode: this.schoolAdrCode,
          discoverChoice: this.discoverChoice,
          discoverMore: this.discoverMore,
        })
          .then(data => {
            this.inProgress = false
            this.$router.push('/account/signin/done')
          })
          .catch(err => {
            console.log(err)
            this.inProgress = false
            this.errorCaught = 'Veuillez réessayer un peu plus tard'
          })
      },
    },
  }
</script>

<style scoped>
</style>
